(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.hp-header');
    if (!header) return;

    /* Full-page menu - native <dialog> gives focus trapping and Escape for free. */
    const dialog = document.getElementById('HpMobileMenu');
    /*
     * The static header and the sticky bar each carry an opener for the
     * dialog. The menu's own close button wears the same class for the icon,
     * so the openers are picked out by the data attribute instead.
     */
    const toggles = document.querySelectorAll('[data-hp-menu-toggle]');

    if (dialog && toggles.length) {
      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          dialog.showModal();
          toggle.setAttribute('aria-expanded', 'true');
        });
      });
      dialog.querySelector('.hp-menu__close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      });

      /*
       * Only an in-page anchor closes the menu, and it has to: the jump
       * happens underneath a panel that would otherwise stay put. A link to
       * another page is left alone - closing it there animates the menu off
       * the old page for a moment before the new one paints, which reads as a
       * flicker rather than a transition. `tel:` and `mailto:` are left alone
       * for the same reason: the menu is still there on the way back.
       */
      dialog.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link) return;

        const target = new URL(link.href, window.location.href);
        const samePage =
          target.pathname === window.location.pathname &&
          target.search === window.location.search;
        if (target.hash && samePage) dialog.close();
      });
    }

    /*
     * Sticky navigation. The wordmark section marks itself with
     * `data-hp-sticky-trigger`; the pill appears once that element's bottom
     * edge passes 74px from the top of the viewport, matching the design.
     * Pages without a wordmark fall back to the header itself.
     */
    const sticky = document.querySelector('[data-hp-sticky-nav]');
    if (!sticky) return;

    const trigger = document.querySelector('[data-hp-sticky-trigger]') || header;

    /*
     * When the trigger's section is pinned (the scroll-stack effect), its own
     * bottom edge never travels past the top of the viewport, so the section
     * that slides over it becomes the trigger instead: the pill appears at the
     * moment the wordmark is covered.
     */
    const pinned = trigger.closest('.shopify-section');
    const cover =
      pinned && pinned.querySelector(':scope > .hp-scroll-behind')
        ? pinned.nextElementSibling
        : null;
    const onScrollUp = sticky.dataset.reveal === 'scroll-up';
    const MIN_SCROLL = 80;
    let visible = null;
    let lastY = window.scrollY;
    let goingUp = false;

    const update = () => {
      const y = window.scrollY;
      // A small threshold stops trackpad jitter flickering the bar.
      if (Math.abs(y - lastY) > 6) {
        goingUp = y < lastY;
        lastY = y;
      }

      /*
       * A short trigger - the mobile header is only ~60px tall - already sits
       * above the 74px line at the top of the page, so the offset alone is not
       * enough. The bar also has to wait until the page has actually scrolled
       * clear of the static header.
       */
      const edge = cover
        ? cover.getBoundingClientRect().top
        : trigger.getBoundingClientRect().bottom;
      const past = edge <= 74 && y >= MIN_SCROLL;
      const next = past && (onScrollUp ? goingUp : true);

      if (next === visible) return;
      visible = next;
      sticky.classList.toggle('is-visible', next);
      sticky.toggleAttribute('inert', !next);
      sticky.setAttribute('aria-hidden', next ? 'false' : 'true');
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  })();

  /*
   * Scroll-stack. Sections marked `hp-scroll-behind` pin to the top of the
   * viewport while the section after them scrolls up over the top. A run of
   * adjacent marked sections has to hold as one block, so each is pushed down
   * by the combined height of the ones above it - CSS alone cannot know those
   * heights.
   */
  (() => {
    let runs = [];

    /*
     * Adjacency is taken from document order across every section, not from
     * `previousElementSibling`: the header sits in its own section group
     * outside <main>, so it is a sibling of <main> rather than of the sections
     * it stacks with.
     */
    const collect = () => {
      runs = [];
      const sections = Array.from(document.querySelectorAll('.shopify-section'));

      /*
       * A section can ask for the effect from either end. `hp-scroll-behind` on
       * its own root means "I hold". `hp-scroll-over` means "I ride up over the
       * one above me", and which section that is changes per template, so the
       * class lands on that wrapper here rather than from Liquid. Wrapper
       * classes are cleared first so the right one is still chosen after the
       * theme editor moves a section. The header is never a candidate - it has
       * its own opt-in, and a page whose first section rides up should not drag
       * the header into it.
       */
      sections.forEach((section) => section.classList.remove('hp-scroll-behind'));
      sections.forEach((section, i) => {
        if (!section.querySelector(':scope > .hp-scroll-over')) return;
        const above = sections[i - 1];
        if (above && !above.querySelector(':scope > .hp-header')) {
          above.classList.add('hp-scroll-behind');
        }
      });

      let previousIndex = -2;

      sections.forEach((section, i) => {
        const holds =
          section.classList.contains('hp-scroll-behind') ||
          section.querySelector(':scope > .hp-scroll-behind');
        if (!holds) return;
        if (i === previousIndex + 1) runs[runs.length - 1].push(section);
        else runs.push([section]);
        previousIndex = i;
      });

      /*
       * The header is part of the header group on every template, so it only
       * holds when the section straight below it holds too. On its own it would
       * pin over pages that never asked for the effect, and the sticky pill
       * already covers that job.
       */
      runs = runs.filter((run) => {
        const loneHeader = run.length === 1 && run[0].querySelector(':scope > .hp-header');
        if (loneHeader) run[0].classList.add('hp-scroll-behind--released');
        return !loneHeader;
      });

      /*
       * The pinned sections are `position: sticky`, which makes a stacking
       * context, and the section sliding over them paints above it. The sticky
       * pill has to clear that section, so it is lifted out to the body - it is
       * `position: fixed`, so nothing about it changes visually.
       */
      const pill = document.querySelector('[data-hp-sticky-nav]');
      if (pill && runs.length && pill.parentElement !== document.body) {
        document.body.append(pill);
      }
    };

    /*
     * The footer slides over the whole of <main> rather than over one section,
     * so <main> is held by the same negative-offset trick: it stops when its
     * last line reaches the foot of the screen, and the room it has to be held
     * in is exactly the footer's height.
     */
    const revealFooter = () => {
      const main = document.querySelector('main');
      if (!main || !document.querySelector('[data-hp-scroll-over]')) return;

      // Its own property name: `--scroll-behind-stack` would inherit into every
      // pinned section inside <main> and carry a whole page height with it.
      main.style.setProperty(
        '--scroll-behind-hold',
        Math.min(0, window.innerHeight - main.offsetHeight) + 'px'
      );
    };

    const layout = () => {
      runs.forEach((run) => {
        /*
         * A tall run cannot all hold at once. The last section is the one the
         * next section slides over, so it has to keep a decent slice of the
         * screen: sections are dropped off the top of the run until the ones
         * above it take no more than 70% of the viewport. Released sections
         * scroll away normally.
         */
        const stacked = (from) =>
          run.slice(from, -1).reduce((total, section) => total + section.offsetHeight, 0);

        let start = 0;
        while (start < run.length - 1 && stacked(start) > window.innerHeight * 0.7) start += 1;

        let offset = 0;
        run.forEach((section, i) => {
          const held = i >= start;
          /*
           * A section taller than the space left for it is pinned by its bottom
           * edge instead, on a negative offset: it scrolls normally until its
           * last line is on screen and only then holds, so nothing below the
           * fold is ever left unreachable.
           */
          const top = Math.min(offset, window.innerHeight - section.offsetHeight);
          section.classList.toggle('hp-scroll-behind--released', !held);
          section.style.setProperty('--scroll-behind-stack', held ? top + 'px' : '0px');
          if (held) offset += section.offsetHeight;
        });
      });
    };

    const refresh = () => {
      collect();
      layout();
      revealFooter();
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        refresh();
      });
    };

    refresh();
    window.addEventListener('resize', schedule, { passive: true });
    /*
     * Heights change as fonts and images land, and in the theme editor. The
     * footer offset is the height of the whole page, so a stale measurement
     * there is worth hundreds of pixels rather than a few.
     */
    window.addEventListener('load', schedule);
    document.fonts?.ready.then(schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-ba-frame]').forEach((frame) => {
        const range = frame.querySelector('[data-ba-range]');
        if (!range) return;
        const set = (value) => {
          range.value = value;
          frame.style.setProperty('--pos', `${range.value}%`);
        };
        const fromPointer = (event) => {
          const rect = frame.getBoundingClientRect();
          set(Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100)));
        };

        /*
         * Pointer drag anywhere on the frame. `touch-action: pan-y` in the CSS
         * leaves vertical swipes to the page, so a phone can still scroll past.
         */
        let dragging = false;
        frame.addEventListener('pointerdown', (event) => {
          dragging = true;
          frame.setPointerCapture(event.pointerId);
          fromPointer(event);
        });
        frame.addEventListener('pointermove', (event) => {
          if (dragging) fromPointer(event);
        });
        const stop = () => {
          dragging = false;
        };
        frame.addEventListener('pointerup', stop);
        frame.addEventListener('pointercancel', stop);
        range.addEventListener('input', () => set(range.value));
        set(range.value);
      });

      const tabs = Array.from(root.querySelectorAll('[data-ba-tab]'));
      const select = (tab, focus) => {
        tabs.forEach((other) => {
          const on = other === tab;
          other.setAttribute('aria-selected', on ? 'true' : 'false');
          other.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', (event) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          select(tabs[(index + step + tabs.length) % tabs.length], true);
        });
      });
    };

    document.querySelectorAll('[data-hp-before-after]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-hp-before-after]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-case-studies"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hp-carousel]').forEach((root) => {
      const track = root.querySelector('[data-carousel-track]');
      const viewport = track?.parentElement;
      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      if (!track || !viewport) return;

      const step = () => {
        const card = track.firstElementChild;
        if (!card) return viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const sync = () => {
        const max = viewport.scrollWidth - viewport.clientWidth - 1;
        prev?.toggleAttribute('disabled', viewport.scrollLeft <= 0);
        next?.toggleAttribute('disabled', viewport.scrollLeft >= max);
      };

      prev?.addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' }));
      viewport.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      const interval = Number(root.dataset.interval) || 6500;
      let current = 0;
      let auto = !reduce && tabs.length > 1;
      let inView = false;
      let paused = false;
      let timer = null;

      const select = (index, focus) => {
        current = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          const on = i === current;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          panels[i].classList.toggle('is-active', on);
        });
        if (focus) tabs[current].focus();
        schedule();
      };

      /*
       * The timer bar is a CSS animation keyed off `is-timing`; removing and
       * re-adding the class after a reflow restarts it from empty, so the bar
       * and the timeout always start together.
       */
      const schedule = () => {
        clearTimeout(timer);
        root.classList.remove('is-timing');
        if (!auto || !inView || paused) return;
        void root.offsetWidth;
        root.classList.add('is-timing');
        timer = setTimeout(() => select(current + 1), interval);
      };

      const stop = () => {
        auto = false;
        schedule();
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          stop();
          select(i);
        });
        tab.addEventListener('keydown', (event) => {
          const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
          if (event.key in keys) {
            event.preventDefault();
            stop();
            select(current + keys[event.key], true);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            stop();
            select(event.key === 'Home' ? 0 : tabs.length - 1, true);
          }
        });
      });

      // Reading a stage should not have it snatched away mid-sentence.
      root.addEventListener('pointerenter', () => {
        paused = true;
        schedule();
      });
      root.addEventListener('pointerleave', () => {
        paused = false;
        schedule();
      });

      new IntersectionObserver(
        ([entry]) => {
          inView = entry.isIntersecting;
          schedule();
        },
        { threshold: 0.35 }
      ).observe(root);
    };

    const start = (scope) => scope.querySelectorAll('[data-hp-process-tabs]').forEach(init);
    start(document);
    document.addEventListener('shopify:section:load', (event) => start(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-hp-process-tabs]');
      if (root) event.target.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hp-quotes]').forEach((root) => {
      const track = root.querySelector('[data-quotes-track]');
      const viewport = root.querySelector('[data-quotes-viewport]');
      const status = root.querySelector('[data-quotes-status]');
      if (!track || !viewport) return;

      const real = Array.from(track.children);
      const count = real.length;
      if (count === 0) return;

      /*
       * Clone the first and last slide so the track can run past either end
       * and be snapped back without the user seeing a rewind.
       */
      if (count > 1) {
        const head = real[0].cloneNode(true);
        const tail = real[count - 1].cloneNode(true);
        head.setAttribute('aria-hidden', 'true');
        tail.setAttribute('aria-hidden', 'true');
        track.append(head);
        track.prepend(tail);
      }

      let index = count > 1 ? 1 : 0;
      let drag = null;
      let offset = 0;

      /*
       * A slide is a viewport width less the peek of the next one, and both the
       * flex basis and this step read that from `--peek`, so the two can never
       * drift apart.
       */
      const shift = () => `translateX(calc(${-index} * (100% - var(--peek)) + ${offset}px))`;

      const place = (animate = true) => {
        track.classList.toggle('is-dragging', !animate);
        track.style.transform = shift();
        const active = count > 1 ? ((index - 1 + count) % count) + 1 : 1;
        if (status) status.textContent = `Testimonial ${active} of ${count}`;
      };

      const settle = () => {
        if (count < 2) return;
        if (index !== 0 && index !== count + 1) return;
        index = index === 0 ? count : 1;
        place(false);
        // Re-enable the transition on the next frame, after the snap has painted.
        requestAnimationFrame(() => requestAnimationFrame(() => track.classList.remove('is-dragging')));
      };

      const go = (delta) => {
        index += delta;
        place();
      };

      root.querySelector('[data-quotes-prev]')?.addEventListener('click', () => go(-1));
      root.querySelector('[data-quotes-next]')?.addEventListener('click', () => go(1));
      track.addEventListener('transitionend', (event) => {
        if (event.target === track && event.propertyName === 'transform') settle();
      });

      viewport.addEventListener('pointerdown', (event) => {
        drag = event.clientX;
        viewport.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });
      viewport.addEventListener('pointermove', (event) => {
        if (drag === null) return;
        offset = event.clientX - drag;
        track.style.transform = shift();
      });
      const release = () => {
        if (drag === null) return;
        const moved = offset;
        drag = null;
        offset = 0;
        track.classList.remove('is-dragging');
        if (moved < -60) go(1);
        else if (moved > 60) go(-1);
        else place();
      };
      viewport.addEventListener('pointerup', release);
      viewport.addEventListener('pointercancel', release);

      place(false);
      requestAnimationFrame(() => track.classList.remove('is-dragging'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
